const roundPrice = (price: number, roundUp?: boolean): number => {
  if (roundUp) {
    if (price < 0) {
      return Math.floor(price);
    }
    return Math.ceil(price);
  }
  return price;
};

export default roundPrice;
